import supabase from "../services/supabaseClient";
import { buildSkippedUserProfile, upsertSkippedUserProfile } from "./userProfileDefaults";

/**
 * Testing only — delete persisted world + room data and restore skipped profile defaults.
 * Keeps auth session and public.users row intact.
 */
export async function deleteUserWorldData(userId) {
  if (!userId) {
    return { ok: false, errors: [{ table: "auth", message: "Not signed in" }], profile: null };
  }

  const errors = [];

  const { error: worldsError } = await supabase.from("worlds").delete().eq("user_id", userId);
  if (worldsError) errors.push({ table: "worlds", message: worldsError.message });

  const { error: roomError } = await supabase.from("room_activity").delete().eq("user_id", userId);
  if (roomError) errors.push({ table: "room_activity", message: roomError.message });

  const { error: lumenError } = await supabase.from("lumen_conversations").delete().eq("user_id", userId);
  if (lumenError) errors.push({ table: "lumen_conversations", message: lumenError.message });

  const { error: sessionsError } = await supabase.from("lumen_sessions").delete().eq("user_id", userId);
  if (sessionsError) errors.push({ table: "lumen_sessions", message: sessionsError.message });

  const { error: profileDeleteError } = await supabase.from("user_profile").delete().eq("user_id", userId);
  if (profileDeleteError) errors.push({ table: "user_profile", message: profileDeleteError.message });

  const profile = buildSkippedUserProfile();
  const profileUpsertError = await upsertSkippedUserProfile(userId, profile);
  if (profileUpsertError) {
    errors.push({ table: "user_profile", message: profileUpsertError.message });
  }

  return { ok: errors.length === 0, errors, profile };
}
